import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FaseInfo} from '../../../_models/ContenitoreInfo';
import {CardFase} from '../contenitore-percorso/contenitore-percorso.model';

// card: larghezza fissa, verticale (Orizzontale); riga: tutta la larghezza, campi affiancati (Timeline);
// colonna: verticale a tutta larghezza (sottofasi affiancate della Timeline); footer: come riga, con «Storia ordine»
// sotto APRI/LANCIA (footer di Info contenitore nella Mappa).
export type LayoutCardFase = 'card' | 'riga' | 'colonna' | 'footer';

/** Feature 166: card di una fase del percorso, uguale nelle tre viste (in Mappa nel pannello di dettaglio). */
@Component({
  selector: 'app-contenitore-percorso-fase',
  templateUrl: './contenitore-percorso-fase.component.html',
  styleUrls: ['./contenitore-percorso-fase.component.scss'],
  standalone: false
})
export class ContenitorePercorsoFaseComponent {
  @Input({required: true}) card!: CardFase;
  @Input() storia = false;
  @Input() layout: LayoutCardFase = 'card';
  @Output() azione = new EventEmitter<CardFase>();
  @Output() storiaFase = new EventEmitter<FaseInfo>();
}
